import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

class ReassignWarningPopup extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onProceed: PropTypes.func
  };

  onClose = () => {
    this.props.onClose();
  };

  onProceed = () => {
    this.props.onProceed();
  };

  render() {
    const { isOpen } = this.props;

    return (
      <Modal
        show={isOpen}
        dialogClassName='confirmation-remove-file-modal'
        backdrop='static'
        container={this}
        id='confirmation-remove-file'
      >
        <Modal.Header>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            If this user has NOT been assigned to any of the parent projects,
            he/she will be assigned to those as the project coordinator.
            Proceed?
          </p>

          <div className='confirm-remove-file-group-btn'>
            <button
              className='btn btn-primary btn-siteone-default'
              onClick={this.onClose}
            >
              Cancel
            </button>
            <button
              className='btn btn-siteone btn-siteone'
              onClick={this.onProceed}
            >
              Proceed
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default ReassignWarningPopup;



// WEBPACK FOOTER //
// ./src/Request-Services/Components/ReassignWarningPopup.js